import { Locale } from "../Locale.ts";

/**
 * UI strings for the hundred chart / multiplication chart settings and
 * preview chrome (`Charts/Settings.tsx`, `Charts/OneHundredChart.tsx`,
 * `Charts/MultiplicationChart.tsx`) — ADR 0051 part 2.
 *
 * The chart's own title ("Hundreds Chart" / "Multiplication Chart") is PDF
 * chrome baked into the document and printed into the on-screen preview's
 * aria-label alongside `charts.previewOfPageSuffix` - that title is part 3's
 * business (ADR 0051 §Part-1-as-built), so only the static suffix is here.
 */
const en = {
    "charts.numberOfMissingNumbersLabel": "Number of Missing Numbers: ",
    "charts.numberOfMissingNumbersAria": "Number of missing numbers",
    "charts.numberOfPagesLabel": "Number of Pages: ",
    "charts.addPageAria": "Add a page",
    "charts.removePageAria": "Remove a page",
    "charts.openChartPdf": "Open the chart PDF",
    "charts.buildingChart": "Building your chart…",
    "charts.previewOfPageSuffix": " — preview of page 1",
} as const;

export type ChartsStringKey = keyof typeof en;

const es = {
    "charts.numberOfMissingNumbersLabel": "Número de números que faltan: ",
    "charts.numberOfMissingNumbersAria": "Número de números que faltan",
    "charts.numberOfPagesLabel": "Número de páginas: ",
    "charts.addPageAria": "Añadir una página",
    "charts.removePageAria": "Quitar una página",
    "charts.openChartPdf": "Abrir el PDF de la tabla",
    "charts.buildingChart": "Preparando tu tabla…",
    "charts.previewOfPageSuffix": " — vista previa de la página 1",
} satisfies Record<ChartsStringKey, string>;

const fr = {
    "charts.numberOfMissingNumbersLabel": "Nombre de nombres manquants : ",
    "charts.numberOfMissingNumbersAria": "Nombre de nombres manquants",
    "charts.numberOfPagesLabel": "Nombre de pages : ",
    "charts.addPageAria": "Ajouter une page",
    "charts.removePageAria": "Supprimer une page",
    "charts.openChartPdf": "Ouvrir le PDF de la table",
    "charts.buildingChart": "Préparation de votre table…",
    "charts.previewOfPageSuffix": " — aperçu de la page 1",
} satisfies Record<ChartsStringKey, string>;

export const chartsStrings: Record<Locale, Record<ChartsStringKey, string>> = { en, es, fr };
